import type { NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Auren',
    studioName: 'Auren Studio',
    description: 'Auren is the portfolio of Aurelia Voss, an independent designer and creative director in London making brands, websites and digital products.',
    url: getOrigin(),
    ogImage: '/images/lummi/about-band.jpg',
    location: 'East London',
    email: 'hello@auren.studio',
    instagram: '@auren.studio',
    hours: ['Monday to Friday, 9 to 6'],
    replyLine: 'Usually replies within a day',
    footerLine: 'Made slowly. Remembered for a long time.',
    copyright: '© 2026 Auren Studio, London',
    socials: [
        { label: 'Instagram', href: 'https://www.instagram.com/auren.studio', handle: '@auren.studio' },
        { label: 'LinkedIn', href: 'https://www.linkedin.com/company/auren-studio', handle: 'Auren Studio' },
        { label: 'Pinterest', href: 'https://www.pinterest.com/aurenstudio', handle: 'aurenstudio' }
    ]
}

export const navigation: NavItem[] = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Work', href: '/work' },
    { label: 'Contact', href: '/contact' }
]
